import React, { useState, useEffect } from 'react';
import './Features.css';

const features = [
  {
    title: "Logging of Data from Backend",
    description: "Logs all network traffic and detected events in a secure backend database for future analysis. Detailed logs include timestamps, source IP, destination IP, protocols, and threat types.",
    icon: <i className="bi bi-database-check"></i>,
  },
  {
    title: "Logs Section",
    description: "A dedicated section dynamically fetching and displaying logs from the backend, with filtering and sorting options by date, IP, threat type, and priority level.",
    icon: <i className="bi bi-clipboard-data"></i>,
  },
  {
    title: "IP Analysis and Abuse Score",
    description: "Analyzes IP addresses using external APIs like AbuseIPDB to calculate abuse scores and flags suspicious IPs.",
    icon: <i className="bi bi-exclamation-diamond"></i>,
  },
  {
    title: "Detection of Malicious IPs",
    description: "Real-time scanning of network traffic to detect malicious IPs based on blacklists or patterns. Alerts are generated for flagged IPs.",
    icon: <i className="bi bi-bug"></i>,
  },
  {
    title: "Priority 1 Alerts",
    description: "High-priority threats trigger prominent visual alerts on the interface with detailed threat information.",
    icon: <i className="bi bi-bell"></i>,
  },
  {
    title: "Dashboard with Overall NIDS Details",
    description: "Centralized dashboard displaying metrics like total traffic monitored, number of threats detected, top 5 suspicious IPs, alerts summary, and graphical network activity.",
    icon: <i className="bi bi-pie-chart"></i>,
  },
  {
    title: "Automatic Mailing for Critical Alerts",
    description: "Automatically sends email notifications for critical alerts with details like IP, threat type, timestamp, and mitigation recommendations.",
    icon: <i className="bi bi-envelope-exclamation"></i>,
  },
];

const FeatureShowcase = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [translateY, setTranslateY] = useState(150); 

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 375) {
        setTranslateY(100);
      } else if (width < 465) {
        setTranslateY(120); 
      } else {
        setTranslateY(150); 
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 2000); 

    return () => clearInterval(interval); 
  }, []);

  return (
    <div className="container">
      <div className="circle">
        <div className="circle-center">KEY FEATURES</div>
        {features.map((feature, index) => (
          <div
            key={index}
            className={`feature ${index === activeFeature ? 'active' : ''}`}
            style={{
              transform: `rotate(${index * (360 / features.length)}deg) translateY(${translateY}px)`,
            }}
            onClick={() => setActiveFeature(index)}
          >
            <div className="dot">{feature.icon}</div>
          </div>
        ))}
      </div>
      <div className="content">
        <h2 style={{ textAlign: 'start' }}>{features[activeFeature].title}</h2>
        <p style={{ textAlign: 'start' }}>{features[activeFeature].description}</p>
      </div>
    </div>
  );
};

export default FeatureShowcase;
